import React from "react";

import moment from "moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { ToggleOff, ToggleOn } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";

import { deleteUser } from "../../services/users";
// import * as auth from '../../util/auth';
import CustomTable from "../CustomTable";
import { fetchChangeStatus } from "../pages/Users/userService";

const TableUsers = ({
  data,
  canEdit,
  canDelete,
  refresh,
  tableReference,
  statusUser,
}) => {
  // console.log("Data -> ", data);
  const MySwal = withReactContent(Swal);
  const history = useNavigate();
  //Get UserId
  // const { userId } = auth.getLoggedInData();

  const columns = [
    {
      title: "Id",
      field: "_id",
      hidden: true,
    },
    {
      title: "First Name",
      field: "firstName",
      //sorting: false,
    },
    {
      title: "Last Name",
      field: "lastName",
      //sorting: false
    },
    {
      title: "Phone",
      field: "phone",
      //sorting: false
    },
    {
      title: "Email",
      field: "email",
      //sorting: false
    },
    {
      title: "Last login",
      field: "lastLogin",
      render: (rowData) => {
        const lastLogin =
          rowData.lastLogin === ""
            ? "-"
            : moment(rowData.lastLogin, "YYYY-MM-DD HH:mm:ss").format(
                "YYYY-MM-DD HH:mm:ss",
              );
        return <span>{lastLogin}</span>;
      },
    },
    {
      title: "Last Status Change",
      field: "lastStatusChange",
      render: (rowData) => {
        const lastLogin = !rowData.lastChange
          ? "-"
          : `${moment(
              rowData.lastChange.dateUpdated,
              "YYYY-MM-DD HH:mm:ss",
            ).format("YYYY-MM-DD HH:mm:ss")}  ${
              rowData.lastChange.modifiedByName
            }`;
        return <span>{lastLogin}</span>;
      },
    },
    {
      title: "ClientId",
      field: "clientId",
      hidden: true,
    },
  ];

  const options = {
    sorting: false,
    search: false,
  };

  let actions = [];
  if (canEdit) {
    actions.push((rowData) => ({
      icon: () => <EditIcon color="primary" />,
      tooltip: "Edit User",
      onClick: () => {
        goToRecord(rowData._id, rowData.clientId);
      },
    }));
  }

  /*if (canDelete) {
    actions.push((rowData) => ({
      icon: () => <DeleteIcon className="text-danger" />,
      tooltip: "Delete User",
      onClick: () => delUser(rowData._id),
    }));
  }*/

  // status User
  if (statusUser) {
    actions.push((rowData) => ({
      icon: () =>
        !rowData.blockedByCommercial ? (
          <ToggleOn style={{ color: "#11c26d", fontSize: "2.5rem" }} />
        ) : (
          <ToggleOff style={{ color: "#86756f35", fontSize: "2.5rem" }} />
        ),
      tooltip: "Change Status User",
      onClick: () => {
        askChangeStatus(rowData._id, !rowData.blockedByCommercial);
      },
    }));
  }

  const goToRecord = (id, clientId) => {
    history("/user-form", { state: { id, clientId } });
  };

  const delUser = (id) => {
    MySwal.fire({
      title: "Are you sure you want to delete this user?",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUser(id).then(([status]) => {
          if (status) {
            refresh();
          }
        });
      }
    });
  };

  const askChangeStatus = (id, statusUser) => {
    MySwal.fire({
      title: "Are you sure you want to block this user?",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        applyChangeStatus(id, statusUser);
      }
    });
  };

  const applyChangeStatus = async (id, statusUser) => {
    await fetchChangeStatus(id, statusUser).then(([status, response]) => {
      if (status) {
        refresh();
      }
    });
  };

  return (
    <div>
      <CustomTable
        pageSize={10}
        options={options}
        columns={columns}
        asyncDataSource={data}
        actions={actions}
        tableReference={tableReference}
      />
    </div>
  );
};
export default TableUsers;
